import { CloseOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { RemoteSearchInput } from '../../../../../../../common/components/RemoteSearchInput/RemoteSearchInput';
import styles from './HighValuePagesAnalytics.module.css';

export const HighValuePagesAnalytics = ({
  busy = false,
}: {
  busy?: boolean;
}) => {
  const [urlSearchValue, setUrlSearchValue] = useState('');
  const [selectedUrls, setSelectedUrls] = useState<string[]>([]);
  const [fetchUrlResults, setFetchUrlResults] = useState<string[]>([]);

  const fetchLandings = async query => {
    const trimmedQuery = query.trim();
    setUrlSearchValue(trimmedQuery);
  };

  const onSelectItem = (selectedItem: string) => {
    setSelectedUrls(state => [...state, selectedItem]);
  };

  const onDeleteItem = (url: string) => {
    setSelectedUrls(state => state.filter(item => item !== url));
  };

  const renderSuggestion = (suggestion: string) => (
    <div className={styles.suggestionContainer} key={suggestion}>
      <div className={styles.suggestion}>{suggestion}</div>
    </div>
  );

  const hide = true;

  if (hide) {
    return null;
  }

  return (
    <div className={styles.container} style={{ maxWidth: '480px' }}>
      <div className={styles.header}>
        # of Contacts that hit high value pages
        <div className={styles.subHeader}>At any point in their journey</div>
      </div>
      <div className={styles.block}>
        <div className={styles.title}>URL contains:</div>
        <div className={styles.searchContainer}>
          <RemoteSearchInput
            value={urlSearchValue}
            placeholder="contains"
            lengthLimit={1}
            disabled={selectedUrls.length >= 10}
            renderSuggestion={renderSuggestion}
            onFetch={fetchLandings}
            results={fetchUrlResults}
            onSelectedItem={onSelectItem}
            className={styles.input}
            style={{
              border: '1px solid var(--color-gray-5)',
              borderRadius: '4px',
            }}
            withSearchIcon
          />
          <div className={styles.selectedValues}>
            {selectedUrls?.map(url => (
              <div className={styles.itemWrapper} key={url}>
                <div className={styles.statistic}>
                  <div className={styles.bar} style={{ width: '0.5%' }} />
                  <div className={styles.statNumbers}>
                    <span className={styles.percentage}>10.7%</span>
                    <span className={styles.number}>No data yet</span>
                  </div>
                </div>
                <div className={styles.selectedUrl} key={url}>
                  {url.toLocaleLowerCase()}
                  <CloseOutlined
                    className={styles.close}
                    onClick={() => onDeleteItem(url)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
